import { useEffect, useState } from 'react';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpGetClientMemberNumber = (clientId: string) => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<number>(0);
    const { t } = useTranslation('newNotifications');

    const getMemberNumber = (id: string) => {
        if (!id || id.trim() === '') {
            setIsReady(true);
            return;
        }

        const { exec, abort } = projectApi.getClientMemberNumber({
            params: { clientId: id },
            onSuccess: res => {
                setData(res.body);
            },
            onError: error => {
                console.error('Error fetching client member number:', error);
                toastHandler.push('error', t('common.error'), t('common.somethingWentWrong'));
            },
            onFinally: () => setIsReady(true),
        });

        exec();
        return abort;
    };

    useEffect(() => {
        if (clientId && clientId.trim() !== '') {
            getMemberNumber(clientId);
        } else {
            setIsReady(true);
        }
    }, [clientId]);

    return { isReady, data, getMemberNumber };
};

export default useHttpGetClientMemberNumber;
